<template>
  <div class="nav">
    <p class="p_class">填写收货信息</p>
    <span class="rt-pos" @click="goBack()"></span>
    <div class="search-box">
      <img class="simcard" src="../assets/img/user.png"/>
      <input class="search-input" maxlength="10" placeholder="请输入姓名" v-model="form.name" icon="el-icon-search"/>
    </div>
    <div class="search-box">
      <img class="simcard" src="../assets/img/simcard.png"/>
      <input class="search-input" maxlength="11" placeholder="请输入手机号" v-model="form.phone" type="tel"/>
    </div>

    <div class="search-box">
      <img class="simcard" src="../assets/img/codes.png"/>
      <input type="text" v-model="form.area" class="search-input" placeholder="请选择省市区" @click="showAddress" onfocus="this.blur()">
    </div>

    <nut-address 
      v-model="showPopup" 
      :province="province" 
      :city="city" 
      :country="country" 
      :town="town" 
      customAddressTitle="请选择所在地区"
      @onChange="onChange" 
      @close="close">
    </nut-address>
    <div class="search-box">
      <img class="simcard" src="../assets/img/codes.png"/>
      <input class="search-input" placeholder="请输入市区详细地址" v-model="form.address"/>
    </div>
    <nut-button block class="elbutton" @click="next">提交信息</nut-button>
    <div class="div_tips">
      <span>特别提醒： </span>
        <!-- 因春节假期及快递停运，2月03日至2月17日提交的补卡，将统一在2月18日上班后陆续安排发出，如确认无异议请点击上方【提交信息】完成支付，造成不便，敬请谅解，谢谢！ -->
        尊敬的用户，我们将在两个工作日内(周末及节假日除外)给您安排发货，请您耐心等待，保持电话畅通，到件后请及时取件，谢谢！
    </div>
  </div>
</template>

<script>

import { wx_area } from "@/api/api.js"; //获取地址
import { changeCard,changeCardInfo } from "@/api/api.js"; //提交补卡数据

export default {
  name:'replacementCard',
  data() {
    return {
      form:{
        area:undefined,
        name:undefined,
        phone:undefined
      },
      showPopup:false,
      province:[], // 省
      city:[],// 市
      country:[],// 县
      town:[], // 镇 必传值：name
    };
  },
  computed: {},
  methods: {
      // 后退到上一页
      goBack(){
        this.$router.go(-1);
      },
      //查询是否填写过信息
      handleReplaceCardInfo(){
        let params = {
          iccid: this.$route.query.iccid,
        }
        changeCardInfo(params).then(res=>{
          if(res.data.code == 200){
            this.form = !!res.data.data ? res.data.data : this.form;
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      },
      getProvince(){
        let params = {}
        wx_area(params).then(res => {
          if(res.data.code == 200){
            this.province = res.data.data
          }
        })
      },
      showAddress(){
        this.showPopup = true 
      },
      onChange(cal){
        if(cal.custom == "province"){
          let params = {
            id:cal.value.id
          }
          wx_area(params).then(res => {
            this.city = res.data.data
          })
        }else if(cal.custom == "city"){
          let params = {
            id:cal.value.id
          }
          wx_area(params).then(res => {
            this.country = res.data.data
          })
        }
        // 判断下一个行政区列表的内容是否有值
        setTimeout(() => {
          if(this[cal.next].length < 1){
            this.showPopup = false
          }
        }, 900);
      },
      close(val){
        this.form.area = val.data.addressStr 
      },
      next(){
        if(!this.form.name || !this.form.phone || !this.form.address || !this.form.area){
          return this.$toast.fail("请输入用户信息");
        }else if(this.form.phone.length !=11){
          return this.$toast.fail("请输入正确的手机号");
        }
        let params = {
          ...this.form,
        }
        params.address = this.form.area + this.form.address;
        params.iccid = this.$route.query.iccid;
        changeCard(params).then(res=>{
          if(res.data.code == 200){
            this.$router.push({
              name: "plans",
              query: {
                iccid: this.$route.query.iccid,
                type:3
              }
            });       
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      },
      // 判断是否是微信浏览器
      isWeiXin() {
        let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return true;
        } else {
          return false;
        }
      },
  },
  created() {
    window.document.title = "补卡申请";
    this.getProvince();
    this.handleReplaceCardInfo();
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.simsheng {
  width: 20px;
  height: 20px;
  position: relative;
  left: 45px;
  top:-2px
}
.dizhiClass{
  width: 80%;
  height: 40px;
  line-height: 40px;
  border: 1.2px solid #999;
  border-radius: 5px;
  outline: none;
  text-indent: 35px;
  // margin-left: 17px;
  // margin-top: 12px;
  margin:0 auto;
  display: block;
}
.p_class{
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  background: #e8283e;
  color:#fff;
};
.search-box {
  position: relative;
  margin: 8% auto 15px;
  text-align: center;
  border: none;
}
.search-box .simcard {
  width: 22px;
  height: 22px;
  margin-left: 7px;
  position: absolute;
  top: 9px;
}
.search-box .search-input {
  width: 80%;
  height: 40px;
  line-height: 40px;
  border: 1.2px solid #999;
  border-radius: 5px;
  text-indent: 35px;
  outline: none;
  font-size: 14px;
}
.elbutton {
  width: 80% !important;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  text-align: center;
  display: block;
  border-right: 10px !important;
  background: #e8283e;
}
// .div_tips{
//   margin-top: 100px;
//   margin-left: 20px;
// }
// .div_tips p{
//   font-size: 14px;
//   margin-top: 10px;
//   color: #999;
// }
.rt-pos{
  position: absolute;
  left: 20px;
  top:14px;
  width: 12px;
  height: 12px;
  border-top: 2px solid gainsboro;
  border-left: 2px solid gainsboro;
  transform: rotate(-45deg);
}
.div_tips{
  width: 80%;
  margin: 20px auto;
  span{
    font-size: 14px;
    color: red;
  }
}
/deep/ .nut-cell .nut-cell-title {
  color:#999 !important;
  display: inline-block;
  width: 85px;
  margin-left: 10px;
}
/deep/ .nut-cell .nut-cell-right{
  margin-right: 10px;
  font-size: 14px;
}
/deep/ .nut-cell-box{
  background:none;
  width: 84%;
  border: 1.2px solid #999 !important;
  margin: 0 auto;
  border-radius: 5px;
}
/deep/ .nut-cell:only-of-type{
  background: none;
  margin-top: 25px;
}
/deep/ .nut-cell .nut-cell-box{
  min-height:40px ;
}
</style>
